// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_uGM","cls2":"ReportList-cls2_-SC ReportList-cls1_uGM"};